import MobxWrap from '@/components/MobxWrap';
import { useMemo } from 'react';
import { getTag } from '@/pages/product/config/DisplayTag.config';
import styles from './index.module.less';

const SocialMediaLogo = (props) => {
  const {
    area: {
      country,
      country: { X_Language },
    },
    app: { isMobile },
    product: { productDetail, curSelectCommodityId },
  } = props;

  const tags = useMemo(() => {
    if (country?.code === 'JP' && ![26, 29].includes(productDetail.id)) return [];

    let tagsList = [];
    const tempList = getTag({ pid: productDetail.id, cid: curSelectCommodityId, country, isMobile });
    // AcePro_awardsEN 仅展示HK EN地区
    tempList.forEach((item) => {
      if (item.name !== 'AcePro_awardsEN' || X_Language !== 'zh_tw' || country?.code !== 'HK') {
        tagsList.push(item);
      }
    });

    return tagsList;
  }, [country, curSelectCommodityId, isMobile, productDetail.id]);

  return (
    <div className={styles.logoWrap} data-code={country?.code} data-pid={productDetail.id}>
      {tags.map((item, index) => {
        return (
          <img
            data-special={!!item?.specialHeight}
            height={item?.specialHeight ?? null}
            width={item?.specialWidth ?? null}
            className={styles.imgItem}
            alt=''
            key={index}
            src={item.url}
          />
        );
      })}
    </div>
  );
};

export default MobxWrap(['area', 'app', 'product'], SocialMediaLogo);
